import React, { FunctionComponent, useLayoutEffect, useState } from 'react';
import { Breadcrumb, Button } from 'rs-emd-ui-atoms';
import { LevelChildren } from '.';
import { getCookie, getLabel } from '../../helpers/html.utils';
import { ICategoryListPage } from '../../models/clp/category-list-page.model';
import { IPredictiveSearchService } from '../../services/predictive-search/predictive-search-service';
import { MetaDataAndTagging, RecentlyViewedComponent, SearchField } from '../shared';
import styles from './category-list-page-component.module.scss';

type CategoryListPageProps = {
  showBreadcrumbs?: boolean;
  showTitle?: boolean;
  data: ICategoryListPage;
  isInMenu?: boolean;
  onLevelClick?: () => void;
  predictiveSearchService: IPredictiveSearchService;
};

export const CategoryListPage: FunctionComponent<CategoryListPageProps> = (props: CategoryListPageProps) => {
  const [isReadMoreClicked, setIsReadMoreClicked] = useState(false);
  const [isWebview, setIsWebview] = useState(true);

  useLayoutEffect(() => {
    // webview set in cookie?
    setIsWebview(Boolean(JSON.parse(getCookie('webview') ?? '0'))); // will hide the header
  }, []);

  return (
    <div className={`${styles['clp-container']} ${props.isInMenu ? '' : styles['not-in-menu']}`}>
      {/* Head data */}
      <MetaDataAndTagging metaData={props.data.metaData} tagging={props.data.tagging} />

      <div className={`inner-page-wrapper ${styles.header}`}>
        {!isWebview && props.showBreadcrumbs && <Breadcrumb links={props.data.breadcrumb} className={styles.breadcrumb} />}
        {props.showTitle && <h1 className={styles.title}>{props.data.categoryName}</h1>}
        {props.data.description.length > 0 && props.data.description !== 'SEO TEXT' && getDescription()}

        <div className={styles['search-container']}>
          <SearchField
            predictiveSearchService={props.predictiveSearchService}
            placeholder={getLabel(props.data.labels, 'find_in_category').replace('[category]', props.data.categoryName)}
            isPredictiveSearchEnabled={false}
            familyId={props.data.categoryId}
            trackingData={props.data.categoryName}
            disabledAutofocus={true}
            labels={props.data.labels}></SearchField>
        </div>
      </div>
      <div className={`inner-page-wrapper ${styles.content}`}>
        <LevelChildren categories={props.data.childCategories} labels={props.data.labels} onLevelClick={props.onLevelClick}></LevelChildren>
        <RecentlyViewedComponent
          page='Category'
          removeMobilePadding={true}
          extraData={props.data.categoryName}
          className={styles['recently-viewed']}
        />
      </div>
    </div>
  );

  function getDescription() {
    return (
      <div className={styles['description-container']}>
        <p
          className={`${styles.description} ${isReadMoreClicked ? styles['expand-description'] : ''}`}
          dangerouslySetInnerHTML={{ __html: props.data.description }}></p>
        <Button
          buttonType='link'
          className={styles.link}
          onClick={() => setIsReadMoreClicked(!isReadMoreClicked)}
          text={getLabel(props.data.labels, isReadMoreClicked ? 'read_less' : 'read_more')}
        />
      </div>
    );
  }
};

CategoryListPage.defaultProps = {
  showBreadcrumbs: true,
  showTitle: true,
};
